export default __webpack_public_path__ + "static/media/otege_underground_station.81cd04db.png";